// 主题类型定义
export interface Theme {
  name: string;
  variables: Record<string, string|number|boolean>;
}

// 主题管理器类
export class ThemeManager {
  private currentTheme: string = 'default';
  private themes: Record<string, Theme> = {};

  // 注册主题
  public registerTheme(theme: Theme): void {
    this.themes[theme.name] = theme;
  }

  // 获取当前主题
  public getCurrentTheme(): Theme | null {
    return this.themes[this.currentTheme] || null;
  }

  // 切换主题
  public switchTheme(themeName: string): boolean {
    if (!this.themes[themeName]) {
      console.error(`主题 "${themeName}" 不存在`);
      return false;
    }

    this.currentTheme = themeName;
    this.applyTheme(this.themes[themeName]);
    return true;
  }

  // 应用主题到DOM
  private applyTheme(theme: Theme): void {
    const root = document.documentElement;
    
    // 清除之前的主题变�?
    // ... removed unused computed styles retrieval
    for (const key in this.getAllThemeVariables()) {
      root.style.removeProperty(key);
    }
    
    // 应用新主题变�?
    for (const [key, value] of Object.entries(theme.variables)) {
      root.style.setProperty(`--${key}`, String(value));
    }
    
    // 保存当前主题到localStorage
    localStorage.setItem('current-theme', theme.name);
  }

  // 获取所有主题的所有变�?
  private getAllThemeVariables(): Set<string> {
    const variables = new Set<string>();
    
    for (const theme of Object.values(this.themes)) {
      for (const key in theme.variables) {
        variables.add(`--${key}`);
      }
    }
    
    return variables;
  }

  // 从localStorage加载主题
  public loadSavedTheme(): void {
    const savedTheme = localStorage.getItem('current-theme');
    if (savedTheme && this.themes[savedTheme]) {
      this.switchTheme(savedTheme);
    } else if (this.themes[this.currentTheme]) {
      this.applyTheme(this.themes[this.currentTheme]);
    }
  }
}

// 创建单例实例
const themeManager = new ThemeManager();
export default themeManager;
